import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const Pad = ({ canvasRef, onDraw }) => {
  const drawing = useRef(false);
  useEffect(() => {
    const cv = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    cv.width = cv.offsetWidth * ratio;
    cv.height = cv.offsetHeight * ratio;
    const ctx = cv.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0f172a";
  }, [canvasRef]);
  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    canvasRef.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    onDraw();
  };
  const up = () => { drawing.current = false; };
  return (
    <canvas ref={canvasRef} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
      className="h-56 w-full touch-none rounded-md border-2 border-dashed border-slate-300 bg-white" data-testid="firma-canvas" />
  );
};

export const FirmaDialog = ({ open, onOpenChange, title, description, onSave, children }) => {
  const canvasRef = useRef(null);
  const [vuota, setVuota] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setVuota(true); }, [open]);
  const pulisci = () => {
    const cv = canvasRef.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    setVuota(true);
  };
  const salva = async () => {
    setSaving(true);
    try { await onSave(canvasRef.current.toDataURL("image/png")); onOpenChange(false); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="firma-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
          <DialogDescription>{description || "Firma con il dito o con la penna nel riquadro qui sotto."}</DialogDescription>
        </DialogHeader>
        {children}
        {open && <Pad canvasRef={canvasRef} onDraw={() => setVuota(false)} />}
        <DialogFooter className="gap-2">
          <Button type="button" variant="outline" onClick={pulisci} data-testid="firma-pulisci-button"><Eraser className="mr-1 h-4 w-4" /> Cancella</Button>
          <Button type="button" disabled={vuota || saving} onClick={salva} className="bg-orange-600 hover:bg-orange-700" data-testid="firma-salva-button">{saving ? "Salvataggio..." : "Conferma firma"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
